export const iconFontAwesomeTransportationCarRear = (
	<i className="fa-solid fa-car-rear"></i>
);
